import { POST_ASSOCIATIONS, POST_CLASS_NAME } from '../../post/model/constants'

const REDUX_ASSOCIATION_NON_DELETABLE = {
  [POST_CLASS_NAME]: POST_ASSOCIATIONS
}

export default REDUX_ASSOCIATION_NON_DELETABLE
